import type { PropsWithChildren } from 'react';

import { type IBaseTextProps } from './BaseText'
import { TextStyled } from './styles/TextStyled'

export const Text = (props: PropsWithChildren<IBaseTextProps>) => (
  <TextStyled {...props} />
)

Text.displayName = 'Text'
